import React, { useState, useEffect } from "react";
import {
  Button,
  DocumentViewerATS,
  InfoCardWithCircle,
  Modal,
  // NewTable,
  // NewTableAdv,
  PageHeader,
  PageTitle,
  showToast,
  TableAdv
} from "../../../../../../../components";
import ApplicantsDetailsDrawer from "../../../Modal/ApplicantsDetailsDrawer";
import { mapTableRows } from "../../../../../../../utils";
import { ENDPOINTS } from "../../../../../../../redux/apiConfig";
import ApplicantNotesModal from "../../../Modal/ApplicantDetailsModals/ApplicantNotesModal";
import { addNoteApi } from "../../../../../../../redux/slices/bdmjobs/bdmjobsApi";
import { useDispatch, useSelector } from "react-redux";
import { usePagination } from "../../../../../../../hooks";
// import { getNotes } from "../../../../../../../redux/slices/accountDetails/accountDetailsApi";
import { formatWords2 } from "../../../../../../../utils/stringUtils";
import { getNotes } from "../../../../../../../redux/slices/accountDetails/accountDetailsAPi";
import axiosRequest from "../../../../../../../redux/slices/universal/axiosService";
import { hasContent } from "../../../../../../../utils/common";

const Snapshot = ({ data }) => {
  const { user } = useSelector((state) => state.auth);
  const [detailsDrawer, setDetailsDrawer] = useState(false);
  const [notesModal, setNotesModal] = useState(false);
  const [note, setCandidateNotes] = useState("")
  const [notes, setNotes] = useState([]);
  const [viewModal, setViewModal] = useState(false);
  const [awsUrl, setAwsUrl] = useState("");
  const [awsurlloading, setawsurlLoading] = useState(false)
  const [awsHtmlResume, setAwsHtmlResume] = useState("");
  const [htmlFormat, setHtmlFormat] = useState("");
  const dispatch = useDispatch();
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => { }
  );

  const applicantDetailData = [
    {
      Applicants: 2,
      Submissions: 0,
      Pipeline: 2,
    },
  ];
  const colSnapshot = [
    {
      key: "addedBy",
      label: "Added By",
      columnMenu: false
    },
    {
      key: "addedOn",
      label: "Added On",
      columnMenu: false
    },
    {
      key: "note",
      label: "Note",
      columnMenu: false
    },
    {
      key: "actionPriority",
      label: "Action Priority",
      columnMenu: false
    },
  ];
  let rowSnapshot

  if (notes.length) {
    rowSnapshot = notes.map((item, index) => ({
      id: item._id ?? index,   // use real ID if exists, else fallbac
      addedBy: `${formatWords2(item?.addedBy?.firstName ?? item?.addedBy ?? "")} ${formatWords2(item?.addedBy?.lastName ?? "")}`.trim(),
      addedOn: item?.addedOn
        ? new Date(item.addedOn).toLocaleString("en-US", {
          timeZone: "America/New_York",
          month: "long",
          day: "numeric",
          year: "numeric",
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
          timeZoneName: "short",
        })
        : "--",
      note: item?.note ?? "",
      actionPriority: item?.actionPriority ?? item?.priority ?? "--",
    }));
  } else {
    rowSnapshot = Array.from({ length: data?.notes?.length }, (_, i) => ({
      id: i,
      addedBy: `${formatWords2(data?.notes?.[i]?.addedBy?.firstName)} ${formatWords2(data?.notes?.[i]?.addedBy?.lastName)}`,
      addedOn: new Date(data?.notes?.[i]?.addedOn).toLocaleString("en-US", {
        timeZone: "America/New_York",
        month: "long",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
        timeZoneName: "short",
      }),
      note: data?.notes?.[i]?.note,
      actionPriority: data?.notes?.[i]?.priority,
    }));

  }

  const resumeName = `${data?.firstName} ${data?.lastName}` ?? "resume"
  // const resumeLink = data?.resumes?.at(-1)?.files?.at(-1)?.key ?? ""//?? `Tek Tree LLC/candidates/resumes/11_2025/${data?.uiid}_1_1.docx`
  // const resumePathName = data?.resumes?.at(-1)?.files?.at(-1)?.name ?? resumeName
  const resumeId = data?.resumeIds?.[0]?.id ?? ""


  const handleDownloadResume = async (response) => {
    try {
      // ---------- REPLACE FROM HERE ----------
      // if response is a URL string, just open it directly for download
      if (typeof response === "string" && response.startsWith("http")) {
        const link = document.createElement("a");
        link.href = response;
        // optional: set filename — browsers often ignore cross-origin downloads for filename
        link.download = resumeName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        showToast("Download Successfull", "success", 2000);
        return; // done
      }
      // ---------- TO HERE ----------

      // existing fallback for Blobs/ArrayBuffers (leave as-is)
      let blob = response;
      if (response instanceof ArrayBuffer) blob = new Blob([response]);
      //console.log(blob);
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = resumeName || "resume.docx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
      showToast("Download successful", "success", 2000);
    } catch (error) {
      showToast("Download failed", "error", 2000);
      console.error("Error triggering download:", error && error.message ? error.message : error);
    }
  };

  function extractS3Key(url) {
        return url.replace(/^https?:\/\/[^/]+\//, '');
    }

  const getCandidateResume = async (file) => {
    const resumeLink = file?.key ?? "";
    const resumePathName = file?.name ?? resumeName;

    if (!resumeLink) {
      showToast("Failed to download the resume: No AWS key found for this resume.", "error");
      return;
    }

    const query = new URLSearchParams({
      key: extractS3Key(resumeLink),
      fileName: resumePathName,
      coll: "Candidate",
    }).toString();

    const url = `${ENDPOINTS.CANDIDATES.RESUME_URL}?${query}`;

    try {
       const response= await axiosRequest({method:"GET",url})
      const data = response?.data?.data?.url || "";
      handleDownloadResume(data)
    } catch (err) {
      console.error("Error fetching data:", err);;
    }
  };

  const viewResume = async (file) => {
    const viewResumeLink = file?.key ?? "";
    
    const htmlFormatData = data?.source === 1
    ? data?.htmlResume || "Resume not available"
    : file?.html || "Resume not available";
    setHtmlFormat(htmlFormatData);

    if (!viewResumeLink) {
      showToast("Failed to view the resume: No AWS key found for this resume.", "error");
      return;
    }

    const query = new URLSearchParams({
      key: extractS3Key(viewResumeLink),
      // fileName: resumePathName,
      coll: "Candidate",
      html: true
    }).toString();

    const url = `${ENDPOINTS.CANDIDATES.RESUME_URL}?${query}`;
    setawsurlLoading(true)
    try {
      setAwsUrl("");
      setAwsHtmlResume("")
      const response = await axiosRequest({ method: "GET", url })
      const s3Key = response?.data?.data?.url || "";
      setAwsUrl(s3Key);
      setAwsHtmlResume(response?.data?.data?.htmlContent || "");
      setawsurlLoading(false)
    } catch (err) {
      setawsurlLoading(false)
    } finally {
      setawsurlLoading(false)
    }
  };

  const handleAddNote = async (jobPost, priority) => {
    if (!note.trim()) return;

    try {
      const res = await addNoteApi({
        coll: "Note",
        postActions: ["updateSource"],
        payload: {
          addedBy: user?.data?.uiid,
          candidateId: data.uiid,
          note: note,
          source: 2, // applicant source
          ...(jobPost != null && { jobPostId: jobPost }),
          ...(priority != null && { priority })
        },
      });
      let dataa
      if (res?.success === true) {
        const noteData = await getNotes({
          coll: "Note",
          filters: { candidateId: { type: "NONE", value: data?.uiid } },
          lim: 100,
          pg: 1,
          extret: "uiid firstName lastName",
          ret: "uiid note addedBy addedOn priority",
          sort: { addedOn: -1 },
        });
        setNotesModal(false)
        setCandidateNotes("");
        setNotes(noteData?.data?.data ?? []);
        showToast("Note added successfully", "success", 2000);
        dataa = res?.data?.data || {}
      }
      //if (data?.candidateId && data?.uiid) {
      //dispatch(updateAllSourceNotes({ applicantId: dataa.candidateId, newNoteUiid: dataa.uiid }))
      // dispatch(updateAllOtherSourceNotes({ applicantId: dataa?.candidateId, newNoteUiid: dataa?.uiid }))
      //dispatch(updateApplicantNotes({ applicantId: dataa?.candidateId, newNoteUiid: dataa?.uiid }))
      //}
    }
    catch (error) {
      console.error("Error adding note:", error);
      showToast("Failed to add note", "error", 2000);
    }
  };

  useEffect(() => {
    const mapped = (data?.notes || []).map((n, i) => ({
      id: n?._id || i,
      addedBy: `${n?.addedBy?.firstName || ""} ${n?.addedBy?.lastName || ""}`.trim(),
      addedOn: new Date(n?.addedOn).toISOString(),
      note: n?.note,
      actionPriority: n?.priority,
    }));

    setNotes(mapped);
  }, [data]);

  useEffect(() => {

    const fetchNotes = async () => {
      if (!data?.uiid) return;

      const res = await getNotes({
        coll: "Note",
        filters: { candidateId: { type: "NONE", value: data.uiid } },
        lim: 100,
        pg: 1,
        extret: "uiid firstName lastName",
        ret: "uiid note addedBy addedOn priority",
        sort: { addedOn: -1 },
      });

      setNotes(res?.data?.data ?? []);
    };

    if (notes.length === 0) {
      fetchNotes();
    }
  }, [data?.uiid]);

  
  const mappedRowSnapshot = mapTableRows(rowSnapshot, colSnapshot);
  return (
    <div className="flex-1 rounded-lg m-2 shadow-md overflow-auto p-4 ">
      <PageHeader
        Section={
          <div className="flex justify-start">
            <PageTitle title={"Notes"} tag="h6" />
          </div>
        }
        RightSection={
          <div className="flex gap-3 items-center">
            <InfoCardWithCircle
              data={applicantDetailData}
              size="sm"
              colorDepth="100"
            />
            <Button title={"Add"} onClick={() => setNotesModal(true)} />
          </div>
        }
      />
      <div className="my-4">
        <TableAdv rows={mappedRowSnapshot} columns={colSnapshot} toolbarRight={{ search: false, filter: false, download: false }} />
      </div>
      <h6>Documents</h6>

      {data?.resumes?.length > 0 ? (
        data.resumes.map((resume) =>
          resume?.files?.map((file) => (
            <div
              key={file?._id}
              className="flex items-center my-3 py-6 px-3 rounded shadow"
            >
              <div className="text-primary">
                <Button type="icon" variant="text" icon={"docs"} />
              </div>

              <div className="flex items-center gap-2">
                <p className="font-semibold">{file?.name}</p>

                <span className="text-gray-400 text-xs">
                  (Added on:{" "}
                  {resume?.addedOn &&
                    new Date(resume.addedOn).toISOString().slice(0, 10)}
                  )
                </span>
              </div>

              <div className="flex items-center">
                <Button
                  type="icon"
                  variant="text"
                  color="black"
                  icon={"visibility"}
                  onClick={async () => {
                    setViewModal(true);
                    await viewResume(file);
                  }}
                />

                <Button
                  type="icon"
                  variant="text"
                  color="black"
                  icon={"download"}
                  onClick={() => {
                    getCandidateResume(file);
                  }}
                />

                <Modal
                  width="max-w-6xl"
                  title={formatWords2(resumeName || "Resume Details")}
                  isOpen={viewModal}
                  onClose={() => {
                    setViewModal(false);
                    setAwsUrl("");
                    setAwsHtmlResume("");
                    setHtmlFormat("");
                  }}
                >
                  <DocumentViewerATS
                    AwsResumeUrl={awsUrl || ""}
                    urlLoading={awsurlloading}
                    htmlFormat={
                      hasContent(awsHtmlResume) ? awsHtmlResume : htmlFormat
                    }
                  />
                </Modal>

                {/* <ApplicantsDetailsDrawer
            isOpen={detailsDrawer}
            onClose={() => setDetailsDrawer(false)}
            applicantId={data?.uiid}
          /> */}
              </div>
            </div>
          ))
        )
      ) : (
        <div className="text-center py-6 text-gray-500 font-medium">
          Resume not available
        </div>
      )}
      <ApplicantNotesModal value={note}
        onChange={(e) => {
          const val = e?.target?.value ?? e;
          setCandidateNotes(val);

        }}
        onClick={async (jobPost, priority) => {
          await handleAddNote(jobPost, priority);
        }}

        isOpen={notesModal}
        onClose={() => { setNotesModal(false); setCandidateNotes("") }} />

    </div>
  );
};

export default Snapshot;
